export interface AssistantOrganization {
  id: string;
  name: string;
}

export interface AssistantHelpGuide {
  title: string;
  url: string;
}

export interface AssistantOrganizationDashboards {
  organizations: AssistantOrganization[];
  guide: AssistantHelpGuide | null | undefined;
}

const HELP_CENTER_ORIGIN = "https://support.zeffy.com";

const parseGuide = (guide: unknown): AssistantHelpGuide | null | undefined => {
  if (guide === undefined) {
    return undefined;
  }
  if (
    typeof guide !== "object" ||
    guide === null ||
    !("title" in guide) ||
    !("url" in guide) ||
    typeof guide.title !== "string" ||
    typeof guide.url !== "string" ||
    !URL.canParse(guide.url) ||
    new URL(guide.url).origin !== HELP_CENTER_ORIGIN
  ) {
    return null;
  }
  return { title: guide.title, url: guide.url };
};

export const parseOrganizationDashboards = (output: unknown): AssistantOrganizationDashboards => {
  if (
    typeof output !== "object" ||
    output === null ||
    !("organizations" in output) ||
    !Array.isArray(output.organizations)
  ) {
    return { organizations: [], guide: undefined };
  }
  return {
    organizations: output.organizations.flatMap((organization: Record<string, unknown>): AssistantOrganization[] =>
      typeof organization.id === "string" && typeof organization.name === "string"
        ? [{ id: organization.id, name: organization.name }]
        : []
    ),
    guide: "guide" in output ? parseGuide(output.guide) : undefined,
  };
};
